export default __webpack_public_path__ + "static/media/slider1.e63e6332.jpg";